/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { useMediaQuery } from '../../hooks/mediaQuery';
import { Attraction, BestReview } from '../../types/pages/tour';
import { City } from '../../types/pages/things-to-do';
const DateAndPax = dynamic(() => import('../CalendarAndPax/DateAndPax'));

type INCLUDED = {
  data: string[];
  attractions?: Attraction[];
  longDescription: string;
  rezdyId: string;
  reviewState: {
    average: number;
    total: number;
  };
  bestReview: BestReview | undefined;
  updateTourContext: () => void;
  duration: number;
  privateTour: boolean;
  tourId: string;
  name: string;
  slug?: string;
  shortDescription: string;
  city?: City | undefined;
  bookingCutOffTime: string | null;
  showPax?: boolean;
  productId: string;
};

const Included = ({
  rezdyId,
  updateTourContext,
  privateTour,
  tourId,
  name,
  bestReview,
  city,
  slug,
  showPax,
  productId
}: INCLUDED) => {
  const ref = useRef(null);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (containerRef.current) {
      const containerHeight = containerRef.current.offsetHeight;
      const stopPosition = containerHeight - 900;
    }
  }, []);

  return (
    <>
      <div className="w-full">
        <div className="sm:block md:flex mmd:block">
          <div className="rounded-[24px] shadow-none mmd:shadow-xl">
            <DateAndPax
              rezdyId={rezdyId}
              updateTourContext={updateTourContext}
              mobile={false}
              privateTour={privateTour}
              tourId={tourId}
              name={name}
              slug={slug}
              bestReview={bestReview}
              city={city?.name}
              productId={productId}
            />
          </div>
        </div>

        {showPax && (
          <div className={`py-4 w-full bg px-2 bg-white`}>
            <DateAndPax
              rezdyId={rezdyId}
              updateTourContext={updateTourContext}
              mobile={true}
              privateTour={privateTour}
              tourId={tourId}
              name={name}
              slug={slug}
              bestReview={bestReview}
              city={city?.name}
              productId={productId}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Included;
